var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Interface } from 'ethers/lib/utils';
import { Config } from '../../../../Fct/Config';
import OneInchRouterABI from '../../../../abis/1inch_v5_router.json';
var REJECT_PREV_REQUEST_ERROR = 'reject previous values';
export var isNative = function (address) {
    switch (address.toLowerCase()) {
        case '0x0000000000000000000000000000000000000000':
            return true;
        case '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee':
            return true;
        case 'NATIVE':
            return true;
        default:
            return false;
    }
};
var getTokenAddress = function (address) {
    switch (address.toLowerCase()) {
        case '0x0000000000000000000000000000000000000000':
            return '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';
        case '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee':
            return '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';
        case 'NATIVE':
            return '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';
        default:
            return address;
    }
};
var toNativeAddress = function (address) {
    switch (address.toLowerCase()) {
        case '0x0000000000000000000000000000000000000000':
            return '0x0000000000000000000000000000000000000000';
        case '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee':
            return '0x0000000000000000000000000000000000000000';
        case 'NATIVE':
            return '0x0000000000000000000000000000000000000000';
        default:
            return address;
    }
};
var OneInchHelper = /** @class */ (function (_super) {
    __extends(OneInchHelper, _super);
    function OneInchHelper() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.promiseReject = undefined;
        _this.getSwapParams = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var swapValues, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getSwap(params)];
                    case 1:
                        swapValues = _a.sent();
                        return [2 /*return*/, swapValues];
                    case 2:
                        e_1 = _a.sent();
                        throw new Error(e_1);
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.getSwap = function (_a) {
            var input = _a.input, output = _a.output, slippage = _a.slippage, service = _a.service;
            return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                var _b;
                return __generator(this, function (_c) {
                    (_b = this.promiseReject) === null || _b === void 0 ? void 0 : _b.call(this, REJECT_PREV_REQUEST_ERROR);
                    return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                            var query, queryParams, url, response, _a, data, OneInchRouterInterface, decodedTx, e_2;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        this.promiseReject = reject;
                                        query = {
                                            src: getTokenAddress(input.currency.address),
                                            dst: getTokenAddress(output.currency.address),
                                            amount: input.amount,
                                            from: this.account,
                                            slippage: slippage || '1',
                                            disableEstimate: 'true',
                                        };
                                        queryParams = new URLSearchParams(query);
                                        url = "https://api.1inch.dev/swap/v5.2/".concat(this.chainId, "/swap?").concat(queryParams);
                                        _b.label = 1;
                                    case 1:
                                        _b.trys.push([1, 7, , 8]);
                                        if (!service) return [3 /*break*/, 3];
                                        return [4 /*yield*/, service.create({
                                                cmd: 'simulateSwap',
                                                token_in: getTokenAddress(input.currency.address),
                                                token_out: getTokenAddress(output.currency.address),
                                                token_amount: input.amount,
                                                slippage: slippage || '1',
                                            })];
                                    case 2:
                                        _a = _b.sent();
                                        return [3 /*break*/, 6];
                                    case 3: return [4 /*yield*/, fetch(url, {
                                            method: 'GET',
                                            headers: {
                                                'Content-type': 'application/json',
                                                Authorization: 'Bearer Xpd0MS4ypsyssHKL6LtTTQ8slIUyeQYP',
                                                'Access-Control-Allow-Origin': '*',
                                                'Access-Control-Allow-Methods': 'POST,GET,OPTIONS, PUT, DELETE',
                                            },
                                        })];
                                    case 4: return [4 /*yield*/, (_b.sent()).json()];
                                    case 5:
                                        _a = _b.sent();
                                        _b.label = 6;
                                    case 6:
                                        response = _a;
                                        data = response;
                                        OneInchRouterInterface = new Interface(OneInchRouterABI);
                                        decodedTx = OneInchRouterInterface.parseTransaction({ data: data.tx.data, value: data.tx.value });
                                        if (decodedTx.name === 'swap') {
                                            resolve({
                                                params: {
                                                    value: isNative(input.currency.address) ? decodedTx.args['desc']['amount'].toString() : "0x0",
                                                    methodParams: {
                                                        executor: decodedTx.args['executor'],
                                                        desc_tuple: {
                                                            srcToken: decodedTx.args['desc']['srcToken'],
                                                            dstToken: decodedTx.args['desc']['dstToken'],
                                                            srcReceiver: decodedTx.args['desc']['srcReceiver'],
                                                            dstReceiver: this.account,
                                                            amount: decodedTx.args['desc']['amount'].toString(),
                                                            minReturnAmount: decodedTx.args['desc']['minReturnAmount'].toString(),
                                                            flags: decodedTx.args['desc']['flags'].toString(),
                                                        },
                                                        permit: decodedTx.args['permit'],
                                                        data: decodedTx.args['data'],
                                                    },
                                                },
                                                state: 'VALID',
                                                methodName: decodedTx.name,
                                                inputAmount: decodedTx.args['desc']['amount'].toString(),
                                                outputAmount: decodedTx.args['desc']['minReturnAmount'].toString(),
                                                protocol: '1INCH',
                                            });
                                        }
                                        resolve({
                                            params: {
                                                value: isNative(input.currency.address) ? decodedTx.args['amount'].toString() : "0x0",
                                                methodParams: {
                                                    srcToken: decodedTx.args['srcToken']
                                                        ? decodedTx.args['srcToken']
                                                        : toNativeAddress(input.currency.address),
                                                    amount: decodedTx.args['amount'].toString(),
                                                    minReturn: decodedTx.args['minReturn'].toString(),
                                                    pools: decodedTx.args['pools'].map(function (pool) { return pool.toString(); }),
                                                },
                                            },
                                            state: 'VALID',
                                            methodName: decodedTx.name,
                                            inputAmount: decodedTx.args['amount'].toString(),
                                            outputAmount: decodedTx.args['minReturn'].toString(),
                                            protocol: '1INCH',
                                        });
                                        return [3 /*break*/, 8];
                                    case 7:
                                        e_2 = _b.sent();
                                        reject(e_2);
                                        return [3 /*break*/, 8];
                                    case 8: return [2 /*return*/];
                                }
                            });
                        }); })];
                });
            });
        };
        return _this;
    }
    return OneInchHelper;
}(Config));
export { OneInchHelper };
